import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})

export class WhiteSpacesValidator {

  constructor() { }

  validate(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {

      if (!control.value) {
        return null;
      }

      const isWhitespace = (control.value || '').length > 0 && (control.value || '').trim().length === 0;
      const valid = !isWhitespace;
      return valid ? null : {"whitespaces":true};
    };
  }

}
